import React from 'react';

const RefundPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-midnight py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-6xl font-serif font-bold mb-12 text-center">Refund Policy</h1>
        
        <div className="prose prose-invert max-w-none space-y-8 text-gray-400">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">1. General Policy</h2>
            <p>
              At AstroVidya.net, operated by Boomtech Solution Private Limited, we strive to provide the most accurate and insightful astrological services. Due to the personalized nature of our digital reports and consultation services, we have established the following refund policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">2. Digital Products</h2>
            <p>
              For digital products such as personalized birth charts and reports:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Once the report has been generated and delivered to your email or account, we generally do not offer refunds.</li>
              <li>If there is a technical error in the report generation or if the data provided was processed incorrectly by our system, please contact us within 48 hours for a correction or a full refund.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">3. Consultation Services</h2>
            <p>
              For live consultations with our astrologers:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Cancellations made more than 24 hours before the scheduled appointment are eligible for a full refund.</li>
              <li>Cancellations made within 24 hours of the appointment or "no-shows" are not eligible for a refund.</li>
              <li>If the astrologer is unable to attend the session, you will be offered a choice between rescheduling or a full refund.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">4. Process for Refunds</h2>
            <p>
              To request a refund, please email us at hello@astrovidya.net with your order number and the reason for your request. Approved refunds will be processed back to the original payment method within 7-10 business days.
            </p>
          </section>

          <div className="pt-12 border-t border-white/10 text-center">
            <p className="text-xs text-gray-500 italic">Last Updated: March 31, 2026</p>
            <p className="text-xs text-gray-500 mt-2">© 2026 Boomtech Solution Private Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
